(() => {
  const sectionSelector = "section[id$='__reviews_carousel']";

  const updateRatingLabel = (section) => {
    const label = section.querySelector('.jdgm-rating-text');
    if (!label) return;

    const rating = label.textContent.match(/\d+(?:\.\d+)?/);
    if (!rating) return;

    const nextLabel = `${rating[0]} stars`;
    if (label.textContent.trim() !== nextLabel) {
      label.textContent = nextLabel;
    }
    label.setAttribute('aria-label', nextLabel);
  };

  const syncFallback = (section) => {
    const fallback = section.querySelector('[data-review-fallback]');
    if (!fallback) return;

    fallback.hidden = false;

    const sourceLabel = section.querySelector('.jdgm-rating-text');
    const targetLabel = fallback.querySelector('[data-review-rating]');
    const rating = sourceLabel?.textContent.match(/\d+(?:\.\d+)?/);
    if (targetLabel && rating) {
      const nextLabel = `${rating[0]} stars`;
      if (targetLabel.textContent.trim() !== nextLabel) {
        targetLabel.textContent = nextLabel;
      }
    }
  };

  const initializeSection = (section) => {
    if (section.dataset.reviewCardsInitialized === 'true') return;
    section.dataset.reviewCardsInitialized = 'true';

    updateRatingLabel(section);
    syncFallback(section);

    const observer = new MutationObserver(() => {
      updateRatingLabel(section);
      syncFallback(section);
    });
    observer.observe(section, { childList: true, subtree: true });
  };

  const initialize = () => {
    document.querySelectorAll(sectionSelector).forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
